import axios from "axios";
import React, { useState, useEffect, useContext, useTransition } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const ResetPassword = () => {
    const { apiB2BURL, apiURL, setLoginStatus, setToken } = useContext(ConfigContext);
    const navigate = useNavigate();
    const {t} = useTranslation();
    const dir = localStorage.getItem('dir');
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState(0);
    const [responseMessage, setResponseMessage] = useState("");
    const {reset_password_token} = useParams();
    const handleLogin = async(e) => {
        e.preventDefault();
        const { data } = await axios.post(
            `${apiB2BURL}/Customer/Users/ResetPassword`,
            { password: password, reset_password_token: reset_password_token } 
          );
          
        
        if (data.success) { 
            setMessageType(1);
            setResponseMessage(data.message);
            setPassword("");
            setConfirmPassword("");
        }else{
            setMessageType(0);
            setResponseMessage(data.message);
            setLoading(false);
        }
    }

   

  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*]/.test(password),
  };
    return (
        <main className="" style={{ direction: dir, textAlign: dir === 'rtl' ? 'right' : 'left' }}>
            <Helmet>
                <title>Reset Password - {t('site_name')}</title>
              
            </Helmet>
            

            <div className="" >
                <div className="col-12 brand-sidebar" style={{height: '100px'}}>
                        <div className="">
                            <img
                                src={`/assets/images/Logo/car7_transparent_powered_by.png`}
                                className="logo"
                                onClick={() => window.location = '/'}
                                alt="Ghayar Logo"
                            />
                        </div>
                    </div>
                <div className="row">
                    
                    <div className="col-lg-6 mx-auto">
                        <div className="row justify-content-center">
                        
                            <div className="col-md-6">
                                <div className="heading mb-1 mt-5">
                                    <h2 className="title">{t('reset_password')}</h2>
                                </div>
                                <form onSubmit={handleLogin}>
                                    <label htmlFor="login-password"> {t('password')} (<span className="required">*</span>) </label>
                                    <input type="password" className="form-input form-wide" id="password" name="password" placeholder="Enter your password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                                   
                                    <br /> 

                                    <label htmlFor="login-password"> {t('confirm_password')} (<span className="required">*</span>) </label>
                                    <input type="password" autoComplete="false" className="form-input form-wide" id="confirm_password" name="confirm_password" placeholder="Enter confirm password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                    <div style={{marginTop: '10px'}}>
                                    {
                                        confirmPassword && password !== confirmPassword && <span style={{color: 'red'}}>{t('password_not_match')}</span>
                                    }
                                    </div>
                                    <br />
                                    
                                   
                                    {
                                        messageType === 1 &&
                                        <div className="alert alert-success">
                                         Password has been successfully reset
                                        </div>
                                    }

{
                                        messageType === 0 && responseMessage !== "" &&
                                        <div className="alert alert-danger">
                                         {responseMessage}
                                        </div>
                                    }
                                    <div style={{ fontFamily: "sans-serif", maxWidth: 400 }}>
                                        

                                        <div style={{ marginTop: 16 }}>
                                            <strong>Password Requirements:</strong>
                                            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                            <CheckItem valid={checks.length} text="At least 8 characters" />
                                            <CheckItem valid={checks.uppercase} text="At least 1 uppercase letter (A–Z)" />
                                            <CheckItem valid={checks.lowercase} text="At least 1 lowercase letter (a–z)" />
                                            <CheckItem valid={checks.number} text="At least 1 number (0–9)" />
                                            <CheckItem valid={checks.special} text="At least 1 special character (! @ # $ % ^ & *)" />
                                            </ul>
                                        </div>
                                        </div>
                                   
                                    {
                                         loading === false && password && confirmPassword && password === confirmPassword && password.length > 5? 
                                        <button type="submit" className="btn btn-dark btn-md w-100"> {t('reset_password')} </button>
                                        :<button type="button" disabled className="btn btn-dark btn-md w-100"> {t('reset_password')} </button>
                                    }
                                    <br />

                                    <br />
                                   <center>
                                   <NavLink
                                        to="/login"
                                        style={{
                                            color: '#0d6efd',
                                            textDecoration: 'none',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Back to Login
                                    </NavLink>
                                   </center>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );

    function CheckItem({ valid, text }) {
        return (
          <li style={{ color: valid ? "green" : "red", marginBottom: 4 }}>
            {valid ? "✔" : "✖"} {text}
          </li>
        );
      }
}

export default ResetPassword;